import React from 'react'
import s from './index.module.scss'
import classNames from 'classnames'
import { UseFormRegister } from 'react-hook-form'
import { ISelectOption } from '../../../models/models'
import { ReactComponent as Triangle } from '../../../assets/icons/triangle.svg'

type RequiredProps = {
	register: UseFormRegister<any>
	name: string
	errors?: any
	className?: string
	label?: React.ReactNode
	placeholder?: string
	options: ISelectOption[]
}

type OptionalProps = {
	register?: never
	name?: string
	errors?: never
	className?: string
	label?: React.ReactNode
	placeholder?: string
	options: ISelectOption[]
}

type IProps = React.HTMLProps<HTMLSelectElement> & (RequiredProps | OptionalProps)

const Select: React.FC<IProps> = ({ register, name, errors, className, label, placeholder, options, ...props }) => {
	const reg = register && register(name)

	return (
		<label className={classNames(s.wrapper, className)}>
			{label && <span className={s.label}>{label}</span>}

			<select {...props} {...reg} name={name} onChange={reg ? reg.onChange : props?.onChange} onBlur={reg ? reg.onBlur : props?.onBlur} className={classNames(s.select)}>
				{placeholder && <option value="">{placeholder}</option>}
				{options?.map((i) => (
					<option key={i.value} value={i.value}>
						{i.title}
					</option>
				))}
			</select>

			<Triangle className={classNames(s.icon, { [s.iconPosition]: label })} />

			{errors && name && errors[name] && <span className={s.error}>{errors[name]?.message}</span>}
		</label>
	)
}

export default Select
